(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.araraMetalColorFallbackBound) return;
    window.araraMetalColorFallbackBound = true;

    const applyMetalColorFallback = (root = document) => {
      const fallbackInput = root.querySelector?.(
        'variant-picker[data-template-product-match="true"] input[data-arara-metal-color-fallback="true"]:not(:disabled)'
      );

      if (!fallbackInput || fallbackInput.dataset.araraMetalColorFallbackApplied === 'true') return;

      fallbackInput.dataset.araraMetalColorFallbackApplied = 'true';
      requestAnimationFrame(() => {
        if (!fallbackInput.isConnected || fallbackInput.disabled) return;
        fallbackInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    document.addEventListener('variant:update', (event) => {
      const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
      requestAnimationFrame(() => applyMetalColorFallback(picker || document));
    });

    applyMetalColorFallback();
  })();

  (() => {
    if (window.araraMatintaConditionalPickerBound) return;
    window.araraMatintaConditionalPickerBound = true;

    const matintaProductId = '10394055901483';

    const syncMatintaPicker = (picker) => {
      if (!(picker instanceof Element) || picker.dataset.productId !== matintaProductId) return;

      const selectedItem = picker.querySelector('.arara-variant-option--matinta-item input:checked');
      const isEarrings = selectedItem?.value?.trim().toLowerCase() === 'earrings';

      if (!isEarrings) {
        delete picker.dataset.araraMatintaItem;
        return;
      }

      const sizeInputs = Array.from(
        picker.querySelectorAll('.arara-variant-option--ring-size input[type="radio"]')
      );
      let selectedSize = sizeInputs.find((input) => input.checked && !input.disabled);

      if (!selectedSize) {
        selectedSize = sizeInputs.find((input) => !input.disabled);

        if (selectedSize) {
          sizeInputs.forEach((input) => {
            input.checked = input === selectedSize;
            input.dataset.currentChecked = input === selectedSize ? 'true' : 'false';
          });
        }
      }

      picker.dataset.araraMatintaItem = 'earrings';
    };

    const syncAllMatintaPickers = (root = document) => {
      root
        .querySelectorAll?.(`variant-picker[data-product-id="${matintaProductId}"]`)
        .forEach(syncMatintaPicker);
    };

    document.addEventListener(
      'change',
      (event) => {
        const input = event.target instanceof Element ? event.target.closest('input[type="radio"]') : null;
        const picker = input?.closest(`variant-picker[data-product-id="${matintaProductId}"]`);

        if (picker && input.closest('.arara-variant-option--matinta-item')) {
          syncMatintaPicker(picker);
        }
      },
      true
    );

    document.addEventListener('variant:update', (event) => {
      const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
      requestAnimationFrame(() => {
        if (picker?.isConnected) {
          syncMatintaPicker(picker);
        } else {
          syncAllMatintaPickers();
        }
      });
    });

    syncAllMatintaPickers();
  })();
  } catch(e) { console.error(e); }
})();

})();
